// ref https://github.com/WICG/EventListenerOptions/pull/30
// Passive event listeners, chrome and touch events
export const isPassiveMode = () => {
  let supportsPassiveOption = false;
  try {
    addEventListener(
      'test',
      () => {
        //
      },
      Object.defineProperty({}, 'passive', {
        get() {
          supportsPassiveOption = true;
        },
      }),
    );
  } catch (e) {
    //
  }
  return supportsPassiveOption;
};
